import { render, staticRenderFns } from "./ContactPage.vue?vue&type=template&id=b50ae462&scoped=true"
import script from "./ContactPage.vue?vue&type=script&lang=ts"
export * from "./ContactPage.vue?vue&type=script&lang=ts"
import style0 from "./ContactPage.vue?vue&type=style&index=0&id=b50ae462&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b50ae462",
  null
  
)

export default component.exports